export const getCsrfToken = () => getMetaValue("csrf-token");
function getMetaValue(name: string) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  if (element) {
    return element.getAttribute("content");
  }
}